
import {ENV} from "@/apps/rever-academy/components/Constant";
import { useVuelidate } from '@vuelidate/core'
import { required,email,helpers } from '@vuelidate/validators'
const $ = require('jquery')
const checkName = helpers.regex(/^\D+$/)
import { defineComponent} from 'vue';
import BlogFormService, {RegisterBlogRequest} from "@/apps/rever-academy/services/BlogFormService";


export default defineComponent({
  name: "RegisterBlogForm",
  setup() {
    return { v$: useVuelidate() };
  },
  data(){
    return{
      formData: new RegisterBlogRequest(),
      submitted: false,
      submitting: false,
      error: null,
      options: []
    }
  },
  validations() {
    return {
      formData: {
        firstname: {required, checkName},
        lastname: {required, checkName},
        email: {required, email},
      }
    }
  },
  mounted() {
    $(window).on('keydown', (e: any) => {
      const {
        keyCode
      } = e
      const ESC_KEY = 27

      if (keyCode === ESC_KEY) {
        this.hide()
      }
    })
  },
  computed:{
    successTitle() {
      return ENV.VUE_APP_REGISTER_SUCCESS_TITLE
    },

    formApi() {
      return ENV.VUE_APP_FORM_API
    },

    popup(): JQuery {
      return $('#register_blog_form.bg-overlay').find('.popup')
    },

    bgOverlay() {
      return $("#register_blog_form.bg-overlay")
    },

    academyEmail() {
      return ENV.VUE_APP_ACADEMY_EMAIL
    },

    context() {
      return {
        page_url: location.href,
        page_name: document.title
      }
    }
  },
  methods:{
    show(e: Event, data: any) {
      this.formData = {
        ...this.formData,
        ...data
      }

      setTimeout(() => {
        console.log("show1")
        this.popup.removeClass('animationClose').addClass('animationOpen')

      }, 100)
      $("#register_blog_form.bg-overlay").fadeIn(50)

      e.preventDefault()
    },


    hide() {
      if (this.submitting) return
      setTimeout(() => {
        $("#register_blog_form.bg-overlay").fadeOut(350);
      }, 50)
      this.popup.removeClass('animationOpen').addClass('animationClose')
      $(this.$el).find('.form').find('.error.active').removeClass('active')
      this.reset()
    },

    reset() {
      if (this.submitted) {
        this.formData = new RegisterBlogRequest()
      }
      this.submitted = false
      this.submitting = false
      this.error = null
      this.v$.$reset()
      // this.bgOverlay.css("display","none");
    },

    checkName(str: string) {
      const rex = new RegExp("\\d+")
      return !rex.test(str)
    },

    async submit() {
      const result = await this.v$.$validate()
      console.log(this.v$)
      // if ()
      console.log(`${process.env.contact_from_api}/${process.env.id_submit_form}`)
      if (result) {
        this.submitting = true
        console.log(this.formData)
        const ser: any = {
          data: []
        }
        Object.keys(this.formData).forEach(key => {

          if (Array.isArray(this.formData[key])) {
            this.formData[key].forEach(item => {
              ser.data.push({
                param: key,
                value: item
              })
            })
          } else {
            ser.data.push({
              param: key,
              value: this.formData[key]
            })
          }
        })
        ser.context = this.context
        BlogFormService.submit(ser)
            .then((res) => {
              this.submitted = true

            }).catch((error) => {
          this.error = error

        }).then(() => {
          this.submitting = false
        })
      }


    }

  }
})
